import { register } from "async-ops";
import { callMvcApi  } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const GET_USER_TASK_STATUS_LIST = 'GET_USER_TASK_STATUS_LIST';


export const service = async (data) => {
  const options: object = {
    url:  "/api/lookup/GetStatusLookupList/TASK_STATUS" ,
    method: "GET",
    contentType: 'application/json'
  }
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_USER_TASK_STATUS_LIST, service, mock);
